import { useEffect, useState } from 'react'
import { getSiteCanEdit } from '@/services/siteSettingsService'

/**
 * Stand-in staff rule: the Gateway says yes for a user whose e-mail ends with @rimonim.tech.
 * False while the answer is loading and when it fails, so a staff-only control stays hidden.
 */
export const useIsRimonimStaff = (siteId: string | null | undefined): boolean => {
  const [isStaff, setIsStaff] = useState(false)

  useEffect(() => {
    setIsStaff(false)
    if (!siteId) return
    let cancelled = false
    getSiteCanEdit(siteId)
      .then(canEdit => {
        if (!cancelled) setIsStaff(canEdit)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [siteId])

  return isStaff
}
